export enum ROUTES {
  MAIN = '/',
  COINS = '/coins',
  EXCHANGES = '/exchanges',
  CONVERTER = '/converter',
	NOT_FOUND = '*'
}